export default __webpack_public_path__ + "static/media/Q-2U-HYBRID-FRONT.d34ac03f.png";